import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomTextField } from '@components/Styles/CommonStyle';
import React, { useState } from 'react';
import { TableBody, TableHead } from '@mui/material';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { mobileNumberChange } from './CompanyAccountCreateTablePhone';

const CompanyAccountCreateTablePhoneList = React.memo(({ contactList, setContactList, searchList, setContactParam, search, setSearchList, contactParam }) => {

  // 선택된 row의 ID
  const [selectedId, setSelectedId] = useState(null); 

  // 연락처 수정
  const handleContactUpdate = (id) => {
    setSelectedId(id);
  };
  
  // 연락처 삭제
  const handleContactDelete = (id) => {
    if(search === true){
        const deleteData = searchList.filter((contact) => contact.id === id);
        setSearchList(searchList.filter((contact) => contact.id !== deleteData[0].id));
        setContactList(contactList.filter((contact) => contact.id !== deleteData[0].id));
    }else{
        setContactList(contactList.filter((contact, i) => i !== id));
    }
  };


  return (
    <React.Fragment>
        <CustomTable>
            <TableHead>
                <CustomTableRow>
                <CustomHeaderCell align="center">성명</CustomHeaderCell>
                <CustomHeaderCell align="center">담당업무</CustomHeaderCell>
                <CustomHeaderCell align="center">일반전화</CustomHeaderCell>
                <CustomHeaderCell align="center">휴대전화</CustomHeaderCell>
                <CustomHeaderCell align="center">이메일</CustomHeaderCell>
                <CustomHeaderCell align="center">관리</CustomHeaderCell>
                </CustomTableRow>
            </TableHead>
            <TableBody>
                {search === false
                ? contactList.map((contact, index) => (
                    <CustomTableRow>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.name} onChange={(e) => {
                                contactList[index].name = e.target.value;
                                setContactParam({ contactList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.duty} onChange={(e) => {
                                contactList[index].duty = e.target.value;
                                setContactParam({ contactList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.phone} onChange={(e) => {
                                contactList[index].phone = e.target.value;
                                setContactParam({ contactList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.mobile} onChange={(e) => {
                                contactList[index].mobile = mobileNumberChange(e.target.value);
                                setContactParam({ contactList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.email} onChange={(e) => {
                                contactList[index].email = e.target.value;
                                setContactParam({ contactList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                        <CustomButton size="small" style={{ marginRight: '10px' }} onClick={() => handleContactUpdate(index)}>
                            수정
                        </CustomButton>
                        <CustomButton size="small" color="error" onClick={() => handleContactDelete(index)}>
                            삭제
                        </CustomButton>
                        </CustomBodyCell>
                    </CustomTableRow>
                    ))
                : searchList.map((contact, index) => (
                    <CustomTableRow>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.name} onChange={(e) => {
                                searchList[index].name = e.target.value;
                                setContactParam({ searchList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.duty} onChange={(e) => {
                                searchList[index].duty = e.target.value;
                                setContactParam({ searchList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.phone} onChange={(e) => {
                                searchList[index].phone = e.target.value;
                                setContactParam({ searchList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.mobile} onChange={(e) => {
                                searchList[index].mobile = mobileNumberChange(e.target.value);
                                setContactParam({ searchList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                            <CustomTextField value={contact.email} onChange={(e) => {
                                searchList[index].email = e.target.value;
                                setContactParam({ searchList });
                            }} disabled={index !== selectedId} />
                        </CustomBodyCell>
                        <CustomBodyCell align="center">
                        <CustomButton size="small" style={{ marginRight: '10px' }} onClick={() => handleContactUpdate(index)}>
                            수정
                        </CustomButton>
                        <CustomButton size="small" color="error" onClick={() => handleContactDelete(contact.id)}>
                            삭제
                        </CustomButton>
                        </CustomBodyCell>
                    </CustomTableRow>
                    ))}
            </TableBody>
        </CustomTable>  
    </React.Fragment>
  );
});

export default CompanyAccountCreateTablePhoneList;

